import React from "react";

import Margin from "../../../../../../shared/Margin";

const ElectricityProduct = ({ consumption, product }) => {
    // get priceGuarantee from product.remarks
    let remarkPriceGuarantee = null;

    if (
        product !== undefined &&
        Object.keys(product).length !== 0 &&
        product.constructor === Object
    ) {
        remarkPriceGuarantee = product.remarks.find(
            (remark) => remark.bedingung === "Preisgarantie"
        );
    }
    return (
        <React.Fragment>
            <div className="box product-details">
                <div className="columns is-mobile">
                    <div className="column ">Bedarf:</div>
                    <div className="column details-value">
                        {consumption} kWh
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column ">Grundpreis:</div>
                    <div className="column details-value">
                        {product ? product.grundpreisBrutto : ""} €/Jahr
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column ">Kilowattstunde:</div>
                    <div className="column details-value">
                        {product ? product.arbeitspreisHTCtKWhBrutto : ""}{" "}
                        ct/kWh
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column">Abschlag:</div>
                    <div className="column details-value">
                        {product ? product.gesamtpreisBruttoProMonat : ""}{" "}
                        €/Monat
                    </div>
                </div>

                <div className="columns is-mobile">
                    <div className="column ">Erneuerbare Energien:</div>
                    <div className="column details-value">
                        {Math.round(product.energyMix.erneuerbare)} %
                    </div>
                </div>

                <div className="columns is-mobile total-amount">
                    <div className="column ">Gesamt:</div>
                    <div className="column">
                        {product.gesamtpreisOhneBoniBrutto}€
                    </div>
                </div>

                <ul>
                    <li>
                        <Margin top="20">
                            <Margin Component="span" right="10">
                                Kündigungsfrist:
                            </Margin>
                            <span style={{ fontWeight: 500 }}>
                                {product.kuendigungsfrist}
                            </span>
                        </Margin>
                    </li>
                    <li>
                        <Margin top="20">
                            <Margin Component="span" right="10">
                                Mindestvertragslaufzeit:
                            </Margin>
                            <span style={{ fontWeight: 500 }}>
                                {product.vertragsverlaengerung}
                            </span>
                        </Margin>
                    </li>
                    {remarkPriceGuarantee && (
                        <li>
                            <Margin top="20">
                                <Margin Component="span" right="10">
                                    eingeschränkte Preisgarantie{" "}
                                    {remarkPriceGuarantee.Beschreibungstext}
                                </Margin>
                                <span style={{ fontWeight: 500 }}>
                                    (
                                    {
                                        remarkPriceGuarantee.preisgarantieBestandteile
                                    }
                                    )
                                </span>
                            </Margin>
                        </li>
                    )}
                </ul>

                {product.isOekogasTarif && (
                    <div>
                        <img
                            alt="Oekostrom Siegel"
                            src="https://www.hoyer-strom-erdgas.de/images/siegel_oekostrom_2018.jpg"
                        />
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default ElectricityProduct;
